module.exports = __webpack_public_path__ + "static/media/development-banner-img1.ad1568c4.svg";